export default __webpack_public_path__ + "static/media/web-rc.36c79904.png";